








import { Component, Vue } from 'vue-property-decorator'
import jwtDecode, { JwtPayload } from 'jwt-decode';

@Component
export default class App extends Vue {
  beforeMount() {
    const token = localStorage.getItem('token');

    if (token == null) {
      this.$router.push('/login');
      return;
    }

    try {
      const decodedJwt = jwtDecode<JwtPayload>(token);

      if (Date.now() >= decodedJwt.exp! * 1000){
        this.$router.push('/login');
        return;
      }
    } catch (e) {
      this.$router.push('/login');
    }
  }
}
